import useCategoryFeedbackFormHandling from './useCategoryFeedbackFormHandling';
import { CharacterAndHabitsUIConfig } from '../../../shared/CategoryStepUIConfig';
import { useViewApplicantAnswers } from './useViewApplicantAnswers';
import { CategoryViewApplicantAnswersStep } from './CategoryViewApplicantAnswersStep';

const UiConfig = CharacterAndHabitsUIConfig;

export const CharacterAndHabitsViewAnswersStep = () => {
	const { application } = useViewApplicantAnswers();

	const { form } = useCategoryFeedbackFormHandling();

	return (
		<CategoryViewApplicantAnswersStep
			uiConfig={UiConfig}
			form={form}
			answers={application?.userAnswers}
		/>
	);
};
